import React, { Component } from 'react';
import { Input } from '../Inputs/CreateEditInput/Input';
import { connect } from 'react-redux';
import { StyledButton, SubmitButton, WorkoutPlanZone, SelectContainer } from './style';
import { Text } from '../../UI/Text';
import { TextArea } from '../Inputs/CreateEditInput/TextArea';
import { OuterIndend } from '../../UI/Indends';
import { Row } from '../../Layouts';
import { Checkbox } from '../Inputs/CreateEditInput/Checkbox';
import { Select } from '../Inputs/CreateEditInput/Select';
import { File } from '../Inputs/CreateEditInput/File';
import { isEmptyObject, getId } from '../../../Utils';
import ModalContainer from '../../Containers/Modals/ModalContainer';
import { ActivityFactoryComponent } from '../../Containers/ActivityList/ActivityList';
import AddWorkoutPlanModal from '../Modals/AddWorkoutPlanModal/AddWorkoutPlanModal';
import AddTrainerModal from '../Modals/AddTrainerModal/AddTrainerModal';
import { UserRow } from '../Rows/UserRow/UserRow';
import { validateClassFormFields } from '../../../Validation/CreateClassValidation';
import {
    getClassCancellationDate,
    serverDateTimeToUtc,
    getFormattedDateFromTimestamp,
} from '../../../Utils/timeConvertorHelper';
import { ErrorMessageBox, StyledInputBackground, StyledLabel } from '../Inputs/CreateEditInput/style';

import { SpinnerBlack } from '../Spiner/SpinnerBlack';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { MultipleSelect } from '../MultipleSelect';
import { CheckMark, SelectItemComponent } from '../Items/SelectItems/SelectItemComponent';
import { Loading } from '../../Containers/WithLoading/Loading';
import { Spinner } from '../Spiner/Spiner';
import { ClassesActionCreators } from '../../../Store/ActionCreators/ClassesActionCreators';
import { MembershipPlansActionCreators } from '../../../Store/ActionCreators/MembershipPlansActionCreators';
import { config } from '../../../Configurations';
import { timeFormats } from '../../../Constants/timeFormats';
import { colorNames } from '../../../Constants/colors';

const getStudioNumberOptions = () => {
    let options = [];

    for (let i = 1; i <= 100; i++) {
        options.push({ value: i, label: `${i}` });
    }

    return options;
};

const typeSelectOptions = [
    { value: 0, label: 'Other' },
    { value: 1, label: 'Animal movement' },
    { value: 2, label: 'Barre' },
    { value: 3, label: 'Bodyweight' },
    { value: 4, label: 'Bootcamp' },
    { value: 5, label: 'Boxing' },
    { value: 6, label: 'Calisthenics' },
    { value: 7, label: 'Circuit Training' },
    { value: 8, label: 'Conditioning' },
    { value: 9, label: 'Core' },
    { value: 11, label: 'Crossfit' },
    { value: 12, label: 'HIIT' },
    { value: 13, label: 'Kettlebell' },
    { value: 14, label: 'Martial arts' },
    { value: 15, label: 'Military' },
    { value: 16, label: 'Pilates' },
    { value: 17, label: 'Spinning' },
    { value: 18, label: 'Stretching' },
    { value: 19, label: 'Swimming' },
    { value: 20, label: 'Tabata' },
    { value: 21, label: 'Water Aerobics' },
    { value: 22, label: 'Weight Training' },
    { value: 23, label: 'Yoga' },
    { value: 24, label: 'Cardio' },
    { value: 25, label: 'Walking' },
    { value: 26, label: 'Running' },
    { value: 27, label: 'Cycling' },
    { value: 28, label: 'Strongman' },
    { value: 29, label: 'trx' },
    { value: 30, label: 'Rowing' },
    { value: 31, label: 'Strength training' },
    { value: 32, label: 'Gym' },
];

const cancellationModeOptions = [
    { value: 0, label: 'Never' },
    { value: 1, label: 'Always allowed' },
    { value: 2, label: '30 minutes' },
    { value: 3, label: '1 hour' },
    { value: 4, label: '2 hours' },
    { value: 5, label: '4 hours' },
    { value: 6, label: '12 hours' },
    { value: 7, label: '24 hours' },
    { value: 8, label: '48 hours' },
    { value: 9, label: '1 week' },
];

class AddClassForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isWorkoutModalOpen: false,
            isTrainerModalOpen: false,
            name: props.name || '',
            // photo: null,
            // image: null,
            displayImage: (props.mediumImage && `${config.baseUrl}/${props.mediumImage}`) || '',
            exerciseType: props.type || 0,
            description: props.description || '',
            roomNumber: props.roomNumber || 1,
            startDate: (props.start && getFormattedDateFromTimestamp(props.start, timeFormats.INPUT_DATE_TYPE)) || '',
            startTime: (props.start && getFormattedDateFromTimestamp(props.start, timeFormats.INCOMPLETE_TIME)) || '',
            endTime: (props.end && getFormattedDateFromTimestamp(props.end, timeFormats.INCOMPLETE_TIME)) || '',
            // endDate: (props.)
            capacity: props.totalClassSeat || '',
            price: props.price || '',
            monday: (props.recurring && this.checkIfRecurring(props.recurring, '1')) || false,
            tuesday: (props.recurring && this.checkIfRecurring(props.recurring, '2')) || false,
            wednesday: (props.recurring && this.checkIfRecurring(props.recurring, '3')) || false,
            thursday: (props.recurring && this.checkIfRecurring(props.recurring, '4')) || false,
            friday: (props.recurring && this.checkIfRecurring(props.recurring, '5')) || false,
            saturday: (props.recurring && this.checkIfRecurring(props.recurring, '6')) || false,
            sunday: (props.recurring && this.checkIfRecurring(props.recurring, '7')) || false,
            cancellationMode: 0,
            plansSelected: [],
            plansAvailable: [],
            workoutPlan: props.workout || {},
            trainer: props.personalTrainer || {},
            errors: {},
            fields: {},
        };
    }

    componentDidMount() {
        this.props.getAvailableMembershipPlans();
        this.getAvailablePlans();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.plans.length === 0 && this.props.plans.length > 0) this.getAvailablePlans();
    }

    checkIfRecurring = (input, number) => {
        if (input.toString().indexOf(number) > -1) {
            return true;
        }

        return false;
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    uploadPhoto = e => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            this.setState({ photo: reader.result });
        };

        if (file) {
            reader.readAsDataURL(file);
            this.setState({ image: file });
        }
    };

    handleCheckboxChange = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    toggleTrainerModal = () => {
        this.setState({ isTrainerModalOpen: !this.state.isTrainerModalOpen });
    };

    toggleWorkoutModal = () => {
        this.setState({ isWorkoutModalOpen: !this.state.isWorkoutModalOpen });
    };

    getSelectedMembershipTypesIds = () => {
        const { plansSelected } = this.state;

        if (plansSelected.length === 0) return [];

        let result = plansSelected.map(plan => plan.value);
        return result;
    };

    formatRecurring = (...days) => {
        let resultStr = '';
        days.forEach((day, index) => {
            if (day) {
                resultStr += `${index + 1}`;
            } else {
                return;
            }
        });

        return resultStr !== '' ? parseInt(resultStr) : null;
    };

    // getUserPlans = () => {
    //     const { plans } = this.props;
    //     const plansSelected = plans.map(plan => {
    //         return { value: plan.plan.data.id, title: plan.plan.data.name };
    //     });

    //     this.setState({ plansSelected });
    // };

    getAvailablePlans = () => {
        const { plans } = this.props;
        const plansAvailable = plans.map(plan => {
            return { value: plan.id, title: plan.name };
        });
        this.setState({ plansAvailable });
    };

    mapMembershipPlansArray = () => {
        const { plansSelected } = this.state;

        if (plansSelected.length > 0) return plansSelected.map(plan => plan.title);

        return [];
    };

    displayPlansSelected = plans => {
        return plans.join(', ');
    };

    selectMembershipPlanItem = item => {
        const { plansSelected } = this.state;
        plansSelected.push(item);
        this.setState({ plansSelected });
    };

    unselectMembershipPlanItem = item => {
        const { plansSelected } = this.state;
        const newArray = plansSelected.filter(plan => plan.value !== item.value);
        this.setState({ plansSelected: newArray });
    };

    handleSubmit = e => {
        e.preventDefault();
        const {
            name,
            image,
            capacity,
            roomNumber,
            exerciseType,
            description,
            startDate,
            startTime,
            endDate,
            endTime,
            price,
            workout_id,
            pt_id,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            cancellationMode,
        } = this.state;

        let validationResult = this.props.isEdit
            ? validateClassFormFields(this.state, true)
            : validateClassFormFields(this.state, false);

        this.setState({ errors: {} });
        this.props.clearErrors();

        if (validationResult.isValid) {
            const recurring = this.formatRecurring(monday, tuesday, wednesday, thursday, friday, saturday, sunday);

            const free_cancel_date = getClassCancellationDate(`${startDate} ${startTime}`, cancellationMode);

            const result = {
                name,
                total_class_seat: capacity,
                type: exerciseType,
                room_number: roomNumber,
                description,
                start: serverDateTimeToUtc(`${startDate} ${startTime}:00`),
                end: serverDateTimeToUtc(`${startDate} ${endTime}:00`),
                price,
                free_cancel_date,
                // image
            };

            if (recurring) {
                if (!this.props.hasOwnProperty('series') || this.props.series === true) {
                    result.recurring = recurring;

                    if (endDate) {
                        result.recurring_end = `${endDate} 00:00:00`;
                    }
                }
            }

            if (pt_id) result.pt_id = pt_id;
            if (workout_id) result.workout_id = workout_id;
            if (image) result.image = image;
            result.plans = this.getSelectedMembershipTypesIds();

            // sending a request
            if (this.props.isEdit) {
                if (this.props.series) {
                    this.props.updateClassSeries(this.props.seriesId, result, () => {
                        // this.props.getClasses();
                        // this.props.closeModal();
                        window.location.reload();
                    });
                    return;
                }
                this.props.updateClass(this.props.id, result, () => {
                    // this.props.getClasses();
                    // this.props.closeModal();
                    window.location.reload();
                });
            } else {
                this.props.createClass(result, () => {
                    // TODO: Refactor ASAP
                    setTimeout(() => {
                        // this.props.getClasses();
                        // this.props.closeModal();
                        window.location.reload();
                    }, 1000);
                });
            }
        } else {
            this.setState({ errors: validationResult.errors });
        }
    };

    addWorkout = workoutPlan => {
        this.setState(prevState => {
            return {
                ...prevState,
                workout_id: workoutPlan.id,
                workoutPlan,
            };
        });
        this.toggleWorkoutModal();
    };

    addTrainer = trainer => {
        this.setState(prevState => {
            return {
                ...prevState,
                pt_id: trainer.id,
                trainer,
            };
        });
        this.toggleTrainerModal();
    };

    deleteClass = () => {
        this.props.deleteClass(this.props.id, () => {
            // this.props.getClasses();
            // this.props.closeModal();
            window.location.reload();
        });
    };

    deleteClassSeries = () => {
        this.props.deleteClassSeries(this.props.seriesId, () => {
            // this.props.getClasses();
            // this.props.closeModal();
            window.location.reload();
        });
    };

    render() {
        const {
            name,
            photo,
            image,
            displayImage,
            exerciseType,
            description,
            roomNumber,
            startDate,
            startTime,
            endTime,
            endDate,
            capacity,
            price,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            plansSelected,
            plansAvailable,
            saturday,
            sunday,
            cancellationMode,
            workoutPlan,
            trainer,
            isWorkoutModalOpen,
            isTrainerModalOpen,
            errors,
        } = this.state;
        const {
            metric,
            isEdit,
            series,
            isClassCreating,
            isClassUpdating,
            arePlansLoading,
            isClassDeleting,
            isClassSeriesDeleting,
            errs: apiErrors,
        } = this.props;

        const studioNumberOptions = getStudioNumberOptions();
        // const membershipPlans = this.mapMembershipPlansArray();

        return (
            <form onSubmit={this.handleSubmit}>
                {isWorkoutModalOpen && (
                    <ModalContainer>
                        <AddWorkoutPlanModal addWorkout={this.addWorkout} onClose={this.toggleWorkoutModal} />
                    </ModalContainer>
                )}

                {isTrainerModalOpen && (
                    <ModalContainer>
                        <AddTrainerModal onClose={this.toggleTrainerModal} addTrainer={this.addTrainer} />
                    </ModalContainer>
                )}

                {/* NAME */}
                <Input
                    label={'Class Name'}
                    type={'text'}
                    name={'name'}
                    value={name}
                    onChange={this.handleChange}
                    error={errors.name}
                />

                {/* PHOTO */}
                <File
                    onChange={this.uploadPhoto}
                    background={image || displayImage}
                    value={photo}
                    error={errors.image}
                    name={'photo'}
                />

                <OuterIndend indend={'30px 0'} />

                {/* EXERCISE TYPE */}

                <Select
                    options={typeSelectOptions}
                    label={'Exercise type'}
                    value={exerciseType}
                    name={'exerciseType'}
                    onChange={this.handleChange}
                />
                <OuterIndend indend={'30px 0'} />

                {/* DESCRIPTION */}
                <TextArea
                    label={'Class description'}
                    name={'description'}
                    placeholder={this.props.textareaPlaceholder}
                    value={description}
                    onChange={this.handleChange}
                    error={errors.description}
                />
                <OuterIndend indend={'30px 0'} />

                {/* ROOM STUDIO NUMBER */}
                <Select
                    options={studioNumberOptions}
                    label={'Studio/Room Number'}
                    value={roomNumber}
                    name={'roomNumber'}
                    onChange={this.handleChange}
                />
                <OuterIndend indend={'30px 0'} />

                {/* START DATE */}
                {/* <DatePickerComponent
                    format={DATE_FORMAT}
                    onChange={this.handleChange}
                    customInput={<CustomDateInput />}
                /> */}

                <Input
                    label={'Date'}
                    type={'date'}
                    name={'startDate'}
                    placeholder={'yyyy-mm-dd'}
                    value={startDate}
                    onChange={this.handleChange}
                    error={errors.startDate}
                    disabled={true}
                />
                <OuterIndend indend={'30px 0'} />

                <Row justify={'space-between'}>
                    {/* START TIME */}
                    <Input
                        size={'small'}
                        type={'time'}
                        label={'Start time'}
                        name={'startTime'}
                        placeholder={'hh:mm'}
                        value={startTime}
                        onChange={this.handleChange}
                        width={'157px'}
                        error={errors.startTime}
                    />

                    {/* END TIME */}
                    <Input
                        size={'small'}
                        type={'time'}
                        label={'End time'}
                        name={'endTime'}
                        placeholder={'hh:mm'}
                        value={endTime}
                        onChange={this.handleChange}
                        width={'157px'}
                        error={errors.endTime}
                    />
                </Row>
                <OuterIndend indend={'30px 0'} />

                {/* RECURRING  */}
                {/* TODO: Create a separate component to map through checkboxes */}
                {series === false ? null : (
                    <React.Fragment>
                        <Text fontSize={16} marginBottom={'16px'} color={colorNames.GREY} weight={'bold'}>
                            Recurring?
                        </Text>

                        <label>
                            <Checkbox
                                checked={monday}
                                name={'monday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Monday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={tuesday}
                                name={'tuesday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Tuesday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={wednesday}
                                name={'wednesday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Wednesday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={thursday}
                                name={'thursday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Thursday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={friday}
                                name={'friday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Friday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={saturday}
                                name={'saturday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Saturday'}
                            />
                        </label>
                        <label>
                            <Checkbox
                                checked={sunday}
                                name={'sunday'}
                                onChange={this.handleCheckboxChange}
                                label={'Every Sunday'}
                            />
                        </label>

                        <OuterIndend indend={'30px 0'} />

                        {/* END DATE */}
                        <Input
                            label={'Recurring end date'}
                            type={'date'}
                            placeholder={'yyyy-mm-dd'}
                            name={'endDate'}
                            value={endDate}
                            onChange={this.handleChange}
                        />
                        <OuterIndend indend={'30px 0'} />
                    </React.Fragment>
                )}

                <div style={{ width: '100%' }}>
                    <Loading isLoading={arePlansLoading}>
                        <MembershipTypesSelect
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectMembershipPlanItem}
                            onUnselect={this.unselectMembershipPlanItem}
                            available={plansAvailable}
                            selected={plansSelected}
                        />
                        <OuterIndend indend={'30px 0'} />
                    </Loading>
                </div>

                <Row justify={'space-between'}>
                    {/* CAPACITY */}
                    <Input
                        size={'small'}
                        type={'number'}
                        min={1}
                        label={'Class capacity'}
                        name={'capacity'}
                        value={capacity}
                        onChange={this.handleChange}
                        error={errors.capacity}
                    />

                    {/* PRICE */}
                    <Input
                        size={'small'}
                        type={'number'}
                        label={'Price in credits'}
                        name={'price'}
                        value={price}
                        onChange={this.handleChange}
                        error={errors.price}
                    />
                </Row>
                <OuterIndend indend={'30px 0'} />

                <Select
                    options={cancellationModeOptions}
                    label={'Free cancellation before'}
                    value={cancellationMode}
                    name={'cancellationMode'}
                    onChange={this.handleChange}
                />
                <OuterIndend indend={'30px 0'} />

                {/* OPTIONAL FIELDS */}
                <Text fontSize={12} weight={'bold'} opacity={'0.5'} alignCenter>
                    OPTIONAL FIELDS
                </Text>
                <OuterIndend indend={'30px 0'} />

                {/* TRAINER */}
                {isEmptyObject(trainer) ? (
                    <EmptyTrainerField onClick={this.toggleTrainerModal} />
                ) : (
                    <FilledTrainerField trainer={trainer} onEdit={this.toggleTrainerModal} />
                )}
                <OuterIndend indend={'30px 0'} />

                {isEmptyObject(workoutPlan) ? (
                    <EmptyWorkoutField onClick={this.toggleWorkoutModal} />
                ) : (
                    <FilledWorkoutField metric={metric} onClick={this.toggleWorkoutModal} workout={workoutPlan} />
                )}
                <OuterIndend indend={'30px 0'} />

                {/* SUBMIT BUTTON */}
                <Row justify={'center'}>
                    <SubmitButton disabled={isClassCreating} type={'submit'}>
                        {isClassCreating || isClassUpdating ? (
                            <SpinnerBlack />
                        ) : (
                            <React.Fragment>{isEdit ? 'EDIT CLASS' : 'ADD CLASS'}</React.Fragment>
                        )}
                    </SubmitButton>
                </Row>

                {/* Loop through API errors */}
                {Object.keys(apiErrors).length > 0 && (
                    <div style={{ width: '100%', margin: '10px 0' }}>
                        <Text alignCenter={true}>Please, check the following errors:</Text>
                        {Object.values(apiErrors).map((err, index) => {
                            return (
                                <ErrorMessageBox key={`error-${index}`} align={'center'} width={'350px'}>
                                    {err}
                                </ErrorMessageBox>
                            );
                        })}
                    </div>
                )}

                {isEdit && (
                    <Row marginTop={'15px'} justify={'center'}>
                        {series ? (
                            <Text onClick={this.deleteClassSeries} cursor={'pointer'} color={'red'} weight={'300'}>
                                {isClassSeriesDeleting ? <Spinner /> : 'Delete class series'}
                            </Text>
                        ) : (
                            <Text onClick={this.deleteClass} cursor={'pointer'} color={'red'} weight={'300'}>
                                {isClassDeleting ? <Spinner /> : 'Delete class'}
                            </Text>
                        )}
                    </Row>
                )}
            </form>
        );
    }
}

const EmptyWorkoutField = ({ onClick }) => (
    <WorkoutPlanZone isEmpty={true}>
        <StyledButton onClick={onClick} type={'button'}>
            ADD WORKOUT PLAN
        </StyledButton>
    </WorkoutPlanZone>
);

const FilledWorkoutField = ({ onClick, workout, metric }) => (
    <React.Fragment>
        <Row width={'100%'} justify={'space-between'}>
            <Text fontSize={16} color={colorNames.GREY} weight={'bold'}>
                Workout plan
            </Text>
            <Text cursor={'pointer'} onClick={onClick} color={'red'} weight={'300'}>
                Edit plan
            </Text>
        </Row>
        <WorkoutPlanZone isEmpty={false}>
            <ActivityFactoryComponent withoutHeader={true} size={'large'} metric={metric} {...workout} />
        </WorkoutPlanZone>
    </React.Fragment>
);

const EmptyTrainerField = ({ onClick }) => (
    <Row justify={'center'}>
        <StyledButton onClick={onClick} type={'button'}>
            ADD TRAINER
        </StyledButton>
    </Row>
);

const FilledTrainerField = ({ trainer, onEdit }) => (
    <React.Fragment>
        <Row>
            <Text fontSize={16} color={colorNames.GREY} weight={'bold'}>
                Trainer
            </Text>
        </Row>
        <OuterIndend />
        <UserRow user={trainer} onEdit={onEdit} />
    </React.Fragment>
);

class MembershipTypesSelect extends Component {
    state = {
        isOpen: false,
    };

    toggleDropDown = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    mapMembershipPlansArray = () => {
        const { selected } = this.props;

        if (selected.length > 0) return selected.map(plan => plan.title);

        return [];
    };

    displayPlansSelected = plans => {
        return plans.join(', ');
    };

    render() {
        const membershipPlans = this.mapMembershipPlansArray();

        return (
            <div style={{ position: 'relative' }}>
                <StyledLabel>Available for which membership types?</StyledLabel>
                <StyledInputBackground onClick={this.toggleDropDown}>
                    <Text fontSize={16}>
                        {membershipPlans && membershipPlans.length > 0
                            ? this.displayPlansSelected(membershipPlans)
                            : 'No plans selected'}
                    </Text>
                </StyledInputBackground>
                {this.state.isOpen && <MultipleSelect onClose={this.toggleDropDown} {...this.props} />}
            </div>
        );
    }
}

AddClassForm.defaultProps = {
    plans: [],
    textareaPlaceholder:
        'Enter a short desciption of your class, Mention the entry level or intensity and what exercises your members should expect.',
};

const mapDispatchToProps = dispatch => ({
    getAvailableMembershipPlans: () => dispatch(MembershipPlansActionCreators.getMembershipPlansRequest()),
    createClass: (data, callback) => dispatch(ClassesActionCreators.createClassRequest(data, callback)),
    updateClass: (classId, classData, callback) =>
        dispatch(ClassesActionCreators.updateClassRequest(classId, classData, callback)),
    updateClassSeries: (seriesId, classData, callback) =>
        dispatch(ClassesActionCreators.updateClassSeriesRequest(seriesId, classData, callback)),
    deleteClass: (classId, callback) => dispatch(ClassesActionCreators.deleteClassRequest(classId, callback)),
    deleteClassSeries: (seriesId, callback) =>
        dispatch(ClassesActionCreators.deleteClassSeriesRequest(seriesId, callback)),
    getClasses: () => {
        const USER_ID = getId(handleLoginService.getUserId());
        dispatch(ClassesActionCreators.getClassesRequest(USER_ID));
    },
    clearErrors: () => {
        dispatch(ClassesActionCreators.clearClassErrors());
    },
});

const mapStateToProps = ({
    user: { currentUserPreferences },
    classes: {
        statuses: { isClassCreating, isClassUpdating, isClassDeleting, isClassSeriesDeleting },
        errs,
    },
    membershipPlans: {
        statuses: { arePlansLoading },
        plans,
    },
}) => ({
    metric: currentUserPreferences.metric,
    isClassCreating,
    isClassUpdating,
    arePlansLoading,
    isClassDeleting,
    isClassSeriesDeleting,
    plans,
    errs,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddClassForm);



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AddClassForm.js